module.exports = __webpack_public_path__ + "img/mastercard-internacional.3aabde81.png";